<template>
  <div class="main">
    <div class="containerBlock">
      <div class="methodsDeposit">
        <div class="tabs">
          <div>
            <span 
              v-for="tab in tabList" 
              :key="tab"
              :class="{ active: currentTab === tab }"
              @click="selectTab(tab)"
            >{{ tab }}</span>
          </div>
        </div>

        <!-- ========== 人工代充：独立渲染 ========== -->
        <div v-if="currentTab === '人工代充'" class="manualList">
          <div 
            class="agent-card" 
            v-for="(item, idx) in manualItems" 
            :key="idx"
          >
            <div class="avatar-box">
              <img 
                 :src="item.avatar" 
                  @error="onAvatarError($event, item)"
                  alt=""
                  >
            </div>

            <div class="info-box">
              <div class="title-row">
                <span class="name">{{ item.name }}</span>
                <span class="bonus-tag" v-if="item.bonus">{{ item.bonus }}</span>
              </div>

              <div class="desc-text" v-if="item.desc">{{ item.desc }}</div>

              <div class="contact-row" v-if="item.wechat">
                <span class="contact-id">{{ item.wechat }}</span>
                <button class="copy-btn" @click="doCopy(item.wechat)">
                  <i class="icon-copy"></i> 复制
                </button>
              </div>
            </div>

            <div class="action-box">
              <button class="deposit-btn" @click="handleManualDeposit(item)">存款</button>
            </div>
          </div>

          <div v-if="!manualItems.length" class="empty">暂无客服</div>
        </div>

        <!-- ========== 其他 Tab：原逻辑 ========== -->
        <ul v-else class="eWalletList">
          <li 
            v-for="method in filteredPaymentMethods" 
            :key="method.pay_type + '_' + method.pay_id"
            :class="{ active: selectedPaymentMethod && selectedPaymentMethod.pay_id === method.pay_id && selectedPaymentMethod.pay_type === method.pay_type }"
            @click="selectPaymentMethod(method)"
          >
            <span v-if="method.bonus">
              <i>{{ method.bonus }}</i>
            </span>
            <div>
              <img :src="method.img" alt="">
              <span>{{ method.name }}</span>
            </div>
          </li>
        </ul>
      </div>

      <!-- ========== 非人工代充时才显示金额设置 + 确认按钮 ========== -->
      <template v-if="currentTab !== '人工代充'">
        <div class="depositAmountSet">
          <h2>
            <span>存款金额</span>
            <a 
              v-if="selectedPaymentMethod && selectedPaymentMethod.download_name && selectedPaymentMethod.download_url" 
              :href="selectedPaymentMethod.download_url" 
              target="_blank" 
              class="download-btn"
            >{{ selectedPaymentMethod.download_name }}</a>
          </h2>
          <div class="amount-input-wrapper">
            <input 
              type="number" 
              v-model="depositAmount" 
              class="amount-input"
              placeholder="请输入存款金额"
              :min="selectedPaymentMethod ? selectedPaymentMethod.min_price : 0"
              :max="selectedPaymentMethod ? selectedPaymentMethod.max_price : 999999"
            >
            <span class="currency">¥</span>
            <div v-if="selectedPaymentMethod && selectedPaymentMethod.remark" class="payment-remark">
              <span>{{ selectedPaymentMethod.remark }}</span>
            </div>
          </div>

          <!-- ★ 新增：USDT 汇率换算提示 -->
          <div v-if="showUsdtTip" class="usdt-tip">
            实际支付：<span class="usdt-amount">{{ usdtAmountText }}</span> USDT
            <span class="usdt-rate">（汇率 1 USDT ≈ {{ selectedPaymentMethod.exchange_rate }} 元）</span>
          </div>

          <div class="quick-amount-grid">
            <span @click="selectAmount(100)" class="quick-btn">100</span>
            <span @click="selectAmount(200)" class="quick-btn">200</span>
            <span @click="selectAmount(500)" class="quick-btn">500</span>
            <span @click="selectAmount(1000)" class="quick-btn">1000</span>
            <span @click="selectAmount(2000)" class="quick-btn">2000</span>
            <span @click="selectAmount(5000)" class="quick-btn">5000</span>
            <span @click="selectAmount(10000)" class="quick-btn">1万</span>
            <span @click="selectAmount(30000)" class="quick-btn">3万</span>
            <span @click="selectAmount(50000)" class="quick-btn">5万</span>
            <span @click="selectAmount(100000)" class="quick-btn">10万</span>
          </div>
        </div>
        <div class="btn">
          <button 
            :class="{ disabled: !canSubmit }"
            @click="confirmDeposit"
          >确认存款</button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recharge',
  data() {
    return {
      pay_way: '',
      bankBox: {},
      payInfo: {},
      amount: null,
      cardLis: [],
      banklist: [],
      meyXi: 'TRC20',
      payWayList: {},
      payTypeList: [],
      payMethods: {},
      currentPayMethods: [],
      selectedMethod: null,
      show: false,
      userbank: [],
      userUSD: [1],
      min_price: 100,
      max_price: 10000,
      currentTab: '热门',
      //tabList: ['热门', '钱包', '人工代充', '其他'],
      tabList: ['热门', '人工代充'],
      categoryMap: {
        '热门': 'hot',
        '钱包': 'wallet',
        '人工代充': 'manual',
        '其他': 'other'
      },
      allPaymentMethods: [],
      selectedPaymentMethod: null,
      depositAmount: '',

      // 人工代充独立数据
      manualItems: [],
      // 默认头像列表：客服按顺序自动对应，超出后循环
      defaultAvatars: [
        '/static/image2/default-avatar.png',
        '/static/image2/default-avatar2.png',
        '/static/image2/default-avatar3.png',
        '/static/image2/default-avatar4.png',
        '/static/image2/default-avatar5.png',
        '/static/image2/default-avatar6.png',
        '/static/image2/default-avatar7.png',
        '/static/image2/default-avatar8.png',
      ],
      defaultAvatar: '/static/image2/default-avatar.png', // 兜底图
    };
  },
  created() {
    let that = this;
    that.getPaymentMethodsFromBackend();
  },
  methods: {
    selectTab(tab) {
      this.currentTab = tab;
      this.getPaymentMethodsFromBackend();
    },

    // ============ 核心：从后端拉支付方式列表 ============
    getPaymentMethodsFromBackend() {
      let that = this;
      that.showLoading();

      const category = that.categoryMap[that.currentTab];

      that.$apiFun
        .get('/api/getAllPaymentMethods', { category })
        .then(res => {
          if (res.code == 200 && res.data) {
            // 人工代充走独立逻辑
            if (that.currentTab === '人工代充') {
              that.handleManualResponse(res.data);
              that.hideLoading();
              return;
            }

            // 其他分类：字段映射（关键修改：pay_type / pay_id）
            that.allPaymentMethods = res.data.map((item, index) => {
              let bonus = '';
              if (item.bonus_ratio) {
                const bonusValue = Math.floor(parseFloat(item.bonus_ratio));
                if (bonusValue > 0) bonus = `送${bonusValue}%`;
              }
              return {
                pay_type: item.pay_type,       // ★ 后端字段：pay_type
                pay_id: item.pay_id,           // ★ 后端字段：pay_id
                channel_id: item.channel_id,
                name: item.name || '支付方式',
                category: that.currentTab,
                img: item.img || '',
                bonus: bonus,
                min_price: parseFloat(item.min_price) || 0,
                max_price: parseFloat(item.max_price) || 999999,
                bonus_ratio: item.bonus_ratio || 0,
                exchange_rate: item.exchange_rate || 0,
                wallet_address: item.wallet_address || '',
                pay_qrcode: item.pay_qrcode || '',
                pay_img: item.pay_img || '',
                remark: item.remark || '',
                download_name: item.download_name || '',
                download_url: item.download_url || ''
              };
            });

            if (that.allPaymentMethods.length > 0) {
              that.selectPaymentMethod(that.allPaymentMethods[0]);
            } else {
              that.selectedPaymentMethod = null;
            }
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },

    // ========== 人工代充：合并所有记录的 manual_items ==========
    handleManualResponse(data) {
      let records = Array.isArray(data) ? data : [data];
      records = records.filter(r => r && typeof r === 'object');

      let allItems = [];
      records.forEach(record => {
        let items = record.manual_items
                || (record.data && record.data.manual_items)
                || [];

        if (typeof items === 'string') {
          try { items = JSON.parse(items); } catch (e) { items = []; }
        }

        if (Array.isArray(items)) {
          allItems = allItems.concat(items);
        }
      });

      const baseUrl = process.env.VUE_APP_BASE_API || '';

      this.manualItems = allItems.map((it, index) => {
        let avatar = (it.avatar || '').replace(/\\/g, '/');
        if (avatar && !/^https?:\/\//.test(avatar) && !avatar.startsWith('data:')) {
          avatar = baseUrl + (avatar.startsWith('/') ? avatar : '/' + avatar);
        }

        if (!avatar) {
          avatar = this.defaultAvatars[index % this.defaultAvatars.length];
        }

        let wechat = it.wechat || '';
        let link   = it.link   || '';

        const legacyUrl = it.url || '';
        if (!wechat && !link && legacyUrl) {
          if (/^https?:\/\//i.test(legacyUrl)) {
            link = legacyUrl;
          } else {
            wechat = legacyUrl;
          }
        }

        return {
          name: it.name || '',
          bonus: it.bonus || '',
          desc: it.desc || '',
          wechat: wechat,
          link: link,
          avatar: avatar,
          defaultAvatar: this.defaultAvatars[index % this.defaultAvatars.length]
        };
      });
    },

    onAvatarError(e, item) {
      e.target.src = (item && item.defaultAvatar) || this.defaultAvatar;
    },

    handleManualDeposit(item) {
      if (!item) return;

      if (item.link) {
        let url = item.link;
        if (!/^https?:\/\//i.test(url)) {
          url = 'http://' + url;
        }
        window.open(url, '_blank');
        return;
      }

      if (item.wechat) {
        this.showTost(1, '请添加客服：' + item.wechat);
        this.doCopy(item.wechat);
      } else {
        this.showTost(0, '暂无联系方式');
      }
    },

    // ============ 选中支付方式 ============
    selectPaymentMethod(method) {
      this.selectedPaymentMethod = method;
      if (method.min_price) { this.min_price = method.min_price; }
      if (method.max_price) { this.max_price = method.max_price; }

      // 兼容老的 pay_way 字段（保留，防止其他地方用）
      if (method.pay_type === 'usdt_pay') {
        this.pay_way = 'usdt';
      } else if (method.pay_type === 'pay_type') {
        this.pay_way = 'bank';
      } else if (method.pay_type === 'manual') {
        this.pay_way = 'manual';
      }
    },

    // ============ 提交充值（核心修改） ============
    confirmDeposit() {
      if (!this.canSubmit) { return; }

      const method = this.selectedPaymentMethod;
      if (!method) {
        this.showTost(0, '请选择支付方式');
        return;
      }

      const amount = Number(this.depositAmount || this.amount);
      if (!amount || amount <= 0) {
        this.showTost(0, '请输入充值金额');
        return;
      }
      if (method.min_price > 0 && amount < method.min_price) {
        this.showTost(0, `最低充值 ${method.min_price}`);
        return;
      }
      if (method.max_price > 0 && amount > method.max_price) {
        this.showTost(0, `最高充值 ${method.max_price}`);
        return;
      }

      this.showLoading();

      // ★ 关键：新参数 pay_type + pay_id
      const params = {
        amount: amount,
        pay_type: method.pay_type,   // 'pay_type' | 'usdt_pay' | 'manual'
        pay_id: method.pay_id,       // 3 | 1 | 18
      };

      this.$apiFun
        .post('/api/recharge', params)
        .then(res => {
          if (res.code != 200) {
            this.showTost(0, res.message || '下单失败');
            this.hideLoading();
            return;
          }
          if (res.code == 200) {
            this.amount = null;
            this.depositAmount = '';

            // 优先判断是否返回第三方支付链接
            if (res.data && res.data.pay_url) {
              // KDpay 等第三方支付，直接跳转
              window.open(res.data.pay_url, '_blank');
              return;
            }

            // 其他方式（USDT、人工代充、静态二维码等），跳转到支付详情页
            this.$router.push({ path: `/payInfo?deposit_no=${res.data.out_trade_no}` });
          }
          this.hideLoading();
        })
        .catch(err => {
          this.hideLoading();
          this.showTost(0, '网络错误');
        });
    },

    selectAmount(val) {
      this.amount = val;
      this.depositAmount = val;
    },

    // ============ 其他辅助方法 ============
    changShow() { this.show = !this.show; },
    onConfirm(value, index) {
      this.bankBox.bank = value.bank_name;
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() { this.show = false; },
    changXiyi(val) {
      if (this.meyXi == val) { return; }
      this.meyXi = val;
    },
    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) { that.showTost(0, res.message); }
          if (res.code == 200) { that.banklist = res.data; }
          that.hideLoading();
        })
        .catch(res => { that.hideLoading(); });
    },
    changMey(val) { this.amount = val * 1; },
    changPayway(val) {
      if (val == that.pay_way) { return; }
      this.pay_way = val;
      this.bankBox = {};
      this.payInfo = {};
      this.amount = null;
      this.selectedMethod = null;
    },
    goNav(url) { this.$parent.goNav(url); },
    doCopy(msg) {
      if (!msg) { return; }
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      cInput.select();
      document.execCommand('copy');
      document.body.removeChild(cInput);
      this.showTost(1, '复制成功！');
    },
    getUserInfo() { this.$parent.getUserInfo(); },
    showLoading() { this.$parent.showLoading(); },
    hideLoading() { this.$parent.hideLoading(); },
    openKefu() { this.$parent.openKefu(); },
    showTost(type, title) { this.$parent.showTost(type, title); },
  },
  computed: {
    filteredPaymentMethods() {
      return this.allPaymentMethods;
    },
    canSubmit() {
      const method = this.selectedPaymentMethod;
      if (!method) return false;
      const amt = Number(this.depositAmount || this.amount);
      if (!amt || amt <= 0) return false;
      if (method.min_price > 0 && amt < method.min_price) return false;
      if (method.max_price > 0 && amt > method.max_price) return false;
      return true;
    },
    // ★ 新增：是否显示 USDT 换算提示
    showUsdtTip() {
      const m = this.selectedPaymentMethod;
      if (!m) return false;
      if (m.pay_type !== 'usdt_pay') return false;
      if (!m.exchange_rate || Number(m.exchange_rate) <= 0) return false;
      const amt = Number(this.depositAmount || this.amount);
      if (!amt || amt <= 0) return false;
      return true;
    },
    // ★ 新增：USDT 换算文本
    usdtAmountText() {
      const m = this.selectedPaymentMethod;
      if (!m || !m.exchange_rate) return '';
      const amt = Number(this.depositAmount || this.amount);
      if (!amt || amt <= 0) return '';
      return (amt / Number(m.exchange_rate)).toFixed(2);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/2d87bbdbffeb4734e5c7.css';

.main {
  width: 100%;
  min-height: 100vh;
  padding: 80px 15px 15px 15px;
  box-sizing: border-box;
}

.containerBlock {
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
}

.tabs {
  margin-bottom: 15px;
  div {
    display: flex;
    background: #f0f0f0;
    border-radius: 30px;
    padding: 4px;
    span {
      flex: 1;
      text-align: center;
      padding: 5px 0;
      border-radius: 30px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      transition: all 0.3s;
      &.active {
        background: linear-gradient(270deg, #3e40ea, #5a77ef);
        color: #fff;
      }
    }
  }
}

.methodsDeposit {
  margin-bottom: 20px;

  .eWalletList {
    display: flex;
    flex-wrap: wrap;
    li {
      width: calc(24.4% - .198rem);
      height: 1.86rem;
      margin-right: .1889rem;
      margin-bottom: 1rem;
      background-color: #fff;
      border-radius: .3rem;
      border: 1px solid #d7d5d5;
      overflow: hidden;
      text-align: center;
      cursor: pointer;
      transition: all .3s;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-content: space-around;

      &.active { border-color: #4a90e2; }

      > span {
        position: absolute;
        top: -0.01rem;
        background: linear-gradient(135deg, #ff6b6b, #fd7f8a);
        color: #fff;
        padding: 0 .1rem;
        font-size: .1rem;
        font-weight: 500;
        z-index: 10;
        line-height: 1.2;
        right: -0.01rem;
        border-radius: 3px;
        i { font-style: normal; }
      }

      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex: 1;
        width: 100%;
        padding-top: 0.4rem;
        img {
          width: 2.32rem;
          height: .82rem;
          object-fit: contain;
          margin-bottom: .05rem;
        }
        span {
          font-size: .33rem;
          font-weight: 500;
          color: #333;
          line-height: 1.3;
          text-align: center;
        }
      }
    }
  }
}

.manualList {
  padding: 4px 0;

  .agent-card {
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 12px;
    border: 1px solid #eee;
    box-shadow: 0 1px 4px rgba(0,0,0,0.04);
    position: relative;

    .avatar-box {
      flex-shrink: 0;
      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid #f2f2f2;
      }
    }

    .info-box {
      flex: 1;
      margin-left: 12px;
      overflow: hidden;

      .title-row {
        display: flex;
        align-items: center;
        margin-bottom: 4px;

        .name {
          font-weight: bold;
          font-size: 15px;
          color: #222;
          max-width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .bonus-tag {
          background: #e74c3c;
          color: #fff;
          font-size: 10px;
          padding: 2px 6px;
          border-radius: 10px;
          margin-left: 8px;
          white-space: nowrap;
        }
      }

      .desc-text {
        color: #888;
        font-size: 12px;
        line-height: 1.5;
        margin-bottom: 4px;
        white-space: pre-line;
      }

      .contact-row {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #666;

        .contact-id {
          max-width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .copy-btn {
          background: none;
          border: none;
          color: #f1c40f;
          margin-left: 6px;
          font-size: 12px;
          cursor: pointer;
          padding: 0;
        }
      }
    }

    .action-box {
      flex-shrink: 0;
      margin-left: 10px;

      .deposit-btn {
        background: #d4af37;
        color: #000;
        border: none;
        padding: 8px 14px;
        border-radius: 6px;
        font-weight: bold;
        font-size: 13px;
        cursor: pointer;

        &:active { opacity: 0.85; }
      }
    }
  }

  .empty {
    text-align: center;
    color: #999;
    padding: 40px 0;
    font-size: 13px;
  }
}

.depositAmountSet {
  margin-bottom: 20px;
  h2 {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0 0 15px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span { display: block; }
    .download-btn {
      color: #3d72fa;
      padding: 4px 12px;
      border-radius: 12px;
      font-size: 12px;
      text-decoration: none;
      &:hover { background: #3a80d2; }
    }
  }

  .amount-input-wrapper {
    position: relative;
    margin-bottom: 15px;
    .amount-input {
      border: none;
      border-bottom: 0.01rem solid #dedede;
      width: 100%;
      outline: none;
      box-sizing: border-box;
      padding: 0.2rem 0;
      background: transparent;
      appearance: none;
      &::placeholder { color: #999; font-size: 13px; }
    }
    .currency {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 14px;
      color: transparent;
      font-weight: 500;
      z-index: 2;
    }
    .payment-remark {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      padding: 2px 6px;
      border-radius: 3px;
      white-space: nowrap;
      z-index: 1;
      span { font-size: 15px; line-height: 1.2; }
    }
  }

  /* ★ 新增：USDT 换算提示 */
  .usdt-tip {
    margin-top: 8px;
    font-size: 13px;
    color: #666;
    line-height: 1.6;

    .usdt-amount {
      color: #e74c3c;
      font-weight: 600;
      font-size: 15px;
    }
    .usdt-rate {
      color: #999;
      font-size: 12px;
      margin-left: 4px;
    }
  }

  .quick-amount-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
    .quick-btn {
      background: #f7f7f7;
      border: 1px solid #f5efef;
      border-radius: 6px;
      padding: 8px 0;
      font-size: 13px;
      color: #333;
      text-align: center;
      cursor: pointer;
      transition: all .3s;
      &:hover {
        background: #e6f0ff;
        border-color: #4a90e2;
        color: #4a90e2;
      }
    }
  }
}

.btn {
  margin-bottom: 15px;
  button {
    width: 100%;
    padding: 12px 0;
    background: #4a90e2;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    &.disabled {
      background: #ccc;
      cursor: not-allowed;
    }
    &:hover:not(.disabled) { background: #3a80d2; }
  }
}

.btns {
  text-align: center;
  div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    span {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #666;
      cursor: pointer;
      img { width: 16px; height: 16px; margin-right: 4px; }
      &:hover { color: #4a90e2; }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/recharge.vue